/** Plafond d'upload, aligné sur `Proposals::Media` côté back. */
export const MAX_MEDIA_SIZE = 100 * 1024 * 1024;

export const MAX_MEDIA_SIZE_LABEL = '100 Mo';

/** Au-delà de ce poids, un envoi sans progression paraît planté. */
export const PROGRESS_THRESHOLD = 2 * 1024 * 1024;

export function isOverMediaSizeLimit(file) {
  return !!file && file.size > MAX_MEDIA_SIZE;
}
